<template>
  <div
    class="multi-select-list"
    role="listbox"
    aria-multiselectable="true"
    :aria-label="ariaLabel || undefined"
    :style="{ maxHeight, minHeight }">
    <div
      v-for="option in options"
      :key="String(option.value)"
      role="option"
      class="multi-select-list__item"
      :class="{ 'multi-select-list__item--selected': isSelected(option.value) }"
      :aria-selected="String(isSelected(option.value))"
      tabindex="0"
      @click="toggle(option.value)"
      @keydown.enter.prevent="toggle(option.value)"
      @keydown.space.prevent="toggle(option.value)">
      {{ option.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiSelectList',
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, required: true },
    maxHeight: { type: String, default: '139px' },
    minHeight: { type: String, default: '69px' },
    ariaLabel: { type: String, default: null },
  },
  computed: {
    selectedSet() {
      return new Set(this.value.map(v => String(v)))
    },
  },
  methods: {
    isSelected(val) {
      return this.selectedSet.has(String(val))
    },
    toggle(val) {
      const strVal = String(val)
      const newValue = this.selectedSet.has(strVal)
        ? this.value.filter(v => String(v) !== strVal)
        : [...this.value, val]
      this.$emit('input', newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.multi-select-list {
  border: 1px solid $grey11;
  border-radius: 4px;
  overflow-y: auto;
  background: #fff;
  width: 100%;

  &__item {
    padding: 3px 10px;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid $grey03;
    user-select: none;
    -webkit-user-select: none;

    &:last-child {
      border-bottom: none;
    }

    &--selected {
      background-color: $primary;
      color: #fff;
      border-bottom-color: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
